<template>
  <div>
    <div
      v-if="paket"
      class="row"
    >
      <div
        class="col-lg-3 col-md-6 col-sm-6"
        v-for="l in paket"
        :key="l.id_paket"
      >
        <div
          class="paket-item card mt-3"
          v-if="l.id_paket != idEdit"
          @click="pilihPaket(l)"
        >
          <div class="card-body">
            <div class="paket-content">
              <div class="paket-icon text-center">
                <img :src="$store.getters.getBaseUrl+'/api/file/'+l.icon">
              </div>
              <h5 class="text-center mt-3">
                {{ l.nama_paket }}
              </h5>
              <div class="mt-3">
                <p
                  v-for="p in l.output_dok"
                  :key="p"
                >
                  <i class="fa fa-check-circle text-success" />
                  {{ p }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="paket-item card mt-3"
          v-if="l.id_paket === idEdit"
        >
          <div class="card-body">
            <div class="paket-content">
              <div class="paket-icon text-center">
                <div
                  :style="{ backgroundImage: 'url('+$store.getters.getBaseUrl+'/api/file/'+l.icon+')' }"
                  @click="editIcon(l)"
                >
                  <i class="fa fa-camera" />
                </div>
              </div>
              <input
                type="text"
                class="form-plain mt-3"
                v-model="formPaket.nama_paket"
                style="
                            text-align:center;
                            font-weight:700;
                            font-size:1.25rem;
                            color:#6c757d
                            "
              >
              <div class="form-group mt-3">
                <label for="">Dokumen Hasil</label>
                <textarea
                  class="form-control"
                  v-model="formPaket.output_dok"
                />
                <small>Pisahkan dengan koma (,)</small>
              </div>
            </div>
          </div>
        </div>
        <div
          class="paket-action"
          v-if="role === 'Operator Dukcapil' || role === 'Operator Dukcapil Kecamatan' || role === 'Admin Laksita' || role === 'Admin Jembrana'"
        >
          <button
            class="btn btn-primary"
            v-if="l.id_paket != idEdit"
            @click="editPaket(l)"
          >
            <i class="fa fa-pencil-alt" />
          </button>
          <button
            class="btn btn-success"
            v-if="l.id_paket === idEdit"
            @click="updatePaket"
          >
            <i class="fa fa-check mr-2" />Simpan
          </button>
          <button
            class="btn btn-danger"
            v-if="l.id_paket === idEdit"
            @click="idEdit = null"
          >
            <i class="fa fa-times" />
          </button>
        </div>
      </div>
    </div>
    <div
      v-else
      class="row"
    >
      <div
        class="col-lg-3 col-md-6 col-sm-6"
        v-for="i in 8"
        :key="i"
      >
        <div class="card mt-3">
          <div class="card-body paket-content">
            <div class="paket-content">
              <div class="paket-icon text-center">
                <div class="content-loader" />
              </div>
              <h5 class="text-center mt-3 content-loader">
                Nama Paket
              </h5>
              <div class="mt-3">
                <p
                  v-for="j in 2"
                  :key="j"
                >
                  <span class="content-loader">Dokumen didapat</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-edit-icon-paket"
      title="Edit Icon Paket"
      v-if="role === 'Admin Laksita' || role === 'Admin Jembrana'"
    >
      <div class="form-group">
        <label for="">Icon</label>
        <input
          type="file"
          class="form-control"
          @change="selectIconPaket"
          accept="image/png, image/jpg, image/jpeg"
        >
      </div>

      <img
        v-if="urlViewImage"
        :src="urlViewImage"
        style="width:100px;height:100px;border-radius:50%"
      >
            
      <template #modal-footer>
        <button
          type="button"
          class="btn btn-primary"
          @click="submitUpdateIconPaket($event)"
        >
          <i class="fa fa-check mr-2" />Simpan
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import swal from 'sweetalert'
export default {
    data() {
        return {
            formPaket: {
                nama_paket: null,
                icon: null,
                output_dok: null,
            },
            idEdit: null,
            urlViewImage: null,
        }
    },
    computed: {
        paket(){
            return this.$store.getters.getPaket
        },
        role(){
            return this.$store.getters.getAuthService.currentRole.nama_role
        }
    },
    props: ['mode', 'type', 'dataPaket'],
    methods: {
        pilihPaket(data){
            if(this.mode === 'buat-permohonan'){
                // console.log(data)
                this.$store.dispatch('selectPaket', data)
                let dataPermohonan = this.$store.getters.getDataPermohonan
                dataPermohonan.tahap = 2
                this.$store.dispatch('setDataPermohonan', dataPermohonan)
            } else if(this.mode === 'info'){
                if(this.type === 'public'){
                    this.$store.dispatch('selectPaket', data)
                    this.$router.push({path: `/layanan/${data.slug}`})
                } else {
                    this.$store.dispatch('selectPaket', data)
                    this.$router.push({path: `/info-layanan/${data.slug}`})
                }
                
            }
        },
        editPaket(l){
            this.idEdit = l.id_paket
            this.formPaket.nama_paket = l.nama_paket
            this.formPaket.output_dok = l.output_dok
        },
        updatePaket(e){
            if(this.formPaket.nama_paket === '' || this.formPaket.nama_paket === null){
                swal({
                    title: "Gagal",
                    text: "Nama Paket Tidak Boleh Kosong",
                    icon: "error",
                    buttons: "Ok"
                })
            }
            if(this.formPaket.output_dok === '' || this.formPaket.output_dok === null){
                swal({
                    title: "Gagal",
                    text: "Dokumen Hasil Tidak Boleh Kosong",
                    icon: "error",
                    buttons: "Ok"
                })
            }


            let button = e.target
            let buttonHtml = button.innerHTML

            button.setAttribute('disabled', true)
            button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Simpan'

            let formData = new FormData()
            formData.append('nama_paket', this.formPaket.nama_paket)
            formData.append('output_dok', this.formPaket.output_dok)

            this.$store.dispatch('updatePaket', {id: this.idEdit, form: formData}).then(res => {
                if(res.data.status){
                    swal({
                        title: "Berhasil",
                        text: res.data.message,
                        icon: "success",
                        buttons: "Ok"
                    })
                    this.idEdit = null
                    this.$store.dispatch('fetchPaket')
                    
                } else {
                    swal({
                        title: "Gagal",
                        text: res.data.message,
                        icon: "error",
                        buttons: "Ok"
                    })
                }
                button.removeAttribute('disabled')
                button.innerHTML = '<i class="fa fa-pencil-alt"></i>'

            }).catch(err => {
                // console.log(err)
                switch(err.response.status){
                    case 500:
                        this.$router.push({path: '/500'})
                        break;

                    case 400:
                        swal({
                            title: "Gagal",
                            text: (typeof(err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
                            icon: "error",
                            buttons: "Ok"
                        })
                        break;
                    
                    default:
                        swal({
                            title: "Gagal",
                            text: err.response.data.message,
                            icon: "error",
                            buttons: "Ok"
                        })
                        break;
                }
                button.removeAttribute('disabled')
                button.innerHTML ='<i class="fa fa-pencil-alt"></i>'
                
            })
        },
        selectIconPaket(e){
            this.formPaket.icon = e.target.files[0]

            this.urlViewImage = URL.createObjectURL(this.formPaket.icon)
        },
        editIcon(l){
            // show modal
            this.$bvModal.show('modal-edit-icon-paket')
        },
        submitUpdateIconPaket(e){
            let button = e.target
            let buttonHtml = button.innerHTML

            button.setAttribute('disabled', true)
            button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Simpan'

            let formData = new FormData()
            formData.append('icon', this.formPaket.icon)

            this.$store.dispatch('updatePaket', {id: this.idEdit, form: formData}).then(res => {
                if(res.data.status){
                    swal({
                        title: "Berhasil",
                        text: res.data.message,
                        icon: "success",
                        buttons: "Ok"
                    })
                    this.idEdit = null
                    this.$bvModal.hide('modal-edit-icon-paket')
                    this.$store.dispatch('fetchPaket')
                    
                } else {
                    swal({
                        title: "Gagal",
                        text: res.data.message,
                        icon: "error",
                        buttons: "Ok"
                    })
                }
                button.removeAttribute('disabled')
                button.innerHTML = '<i class="fa fa-pencil-alt"></i>'

            }).catch(err => {
                // console.log(err)
                switch(err.response.status){
                    case 500:
                        this.$router.push({path: '/500'})
                        break;

                    case 400:
                        swal({
                            title: "Gagal",
                            text: (typeof(err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
                            icon: "error",
                            buttons: "Ok"
                        })
                        break;
                    
                    default:
                        swal({
                            title: "Gagal",
                            text: err.response.data.message,
                            icon: "error",
                            buttons: "Ok"
                        })
                        break;
                }
                button.removeAttribute('disabled')
                button.innerHTML ='<i class="fa fa-pencil-alt"></i>'
                
            })
        }
    },
    mounted(){
        if(!this.dataPaket){
            let dispatch = 'fetchPaket'
            if(this.type === 'public'){
                dispatch = 'fetchPaketPublic'
            } else {
                dispatch = 'fetchPaket'
            }
            this.$store.dispatch(dispatch)
        }
    }
}
</script>